import { useCallback, useEffect, useState } from 'react'
import { useApp } from '../../context/AppContext.jsx'
import { autPendingLeads, autReprocessLeads } from '../../db/api.js'
import { pendingLeadsLabel, reprocessResultLabel } from './leadsPendentes.js'

/**
 * Faixa do editor para a automação "Lead Ads: formulário recebido" (#306): mostra os leads
 * de formulário guardados que ela ainda não processou, inclusive os recebidos antes de ser
 * ativada, e permite rodar a automação para eles agora.
 */
export default function AutomacaoLeadsPendentes({ automationId, disabled }) {
  const { toast } = useApp()
  const [pending, setPending] = useState(null)
  const [running, setRunning] = useState(false)

  const load = useCallback(async () => {
    try {
      setPending(await autPendingLeads(automationId))
    } catch {
      setPending(null)
    }
  }, [automationId])

  useEffect(() => { load() }, [load])

  async function reprocess() {
    setRunning(true)
    try {
      const res = await autReprocessLeads(automationId)
      toast?.(reprocessResultLabel(res.disparados), 'success')
      await load()
    } catch (err) {
      toast?.(err.message || 'Não foi possível processar os leads.', 'error')
    } finally {
      setRunning(false)
    }
  }

  if (!pending || !pending.total) return null
  return (
    <div className="aut-pending" role="status">
      <span>{pendingLeadsLabel(pending.total)}</span>
      <button type="button" className="btn btn-sm btn-outline" onClick={reprocess} disabled={running || disabled}
        title={disabled ? 'Salve as alterações antes de processar' : undefined}>
        {running ? 'Processando…' : 'Processar agora'}
      </button>
    </div>
  )
}
